import React from "react";
import SignUpForm from "./SignUpForm";

function SignUp() {
  return <SignUpForm />;
}

export default SignUp;
